import type { Gateway } from '@lib/api';
import { Dot } from '@ui';
import { toneTextClass } from '@ui/tone';
import { readerStatus } from '@features/gateways/model/reader';

/** One line: is the reader at this location connected? */
export function ReaderLine({ gateways, locationId }: { gateways: Gateway[] | null; locationId: number | null | undefined }) {
  const r = readerStatus(gateways, locationId);
  return (
    <div className={`row tight xs strong ${toneTextClass(r.tone, 'muted')}`}>
      <Dot tone={r.tone} pulse={r.ok} />
      {r.text}
    </div>
  );
}
